import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { CodiceAttivazioneComponent } from './codice-attivazione';

export const CodiceAttivazioneModule: string = ng
    .module('codiceAttivazioneModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('codiceAttivazioneComponent', CodiceAttivazioneComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/codice-attivazione/codice-attivazione.module.ts